import request from '../utils/request'
import setting from './apiSetting'

const TYPE = 'Tracker'
const DEVICE_ICON = 'DeviceIcon'

const myfunction = {
  // 获取设备当前 RFID 识别出的司机及关联车辆
  getTrackerRFIDDrivers: function (ssidArray) {
    return request({
      url: setting.getFullUrl(TYPE, 'GetTrackerRFIDDrivers'),
      method: 'post',
      data: ssidArray,
    })
  },

  EditTrackerIcon: function (data) {
    return request({
      url: setting.getFullUrl(TYPE, 'EditTrackerIcon'),
      method: 'post',
      data: data,
    })
  },

  AddExistTrackers: function (params, data) {
    return request({
      url: setting.getFullUrl(TYPE, 'AddExistTrackers'),
      method: 'post',
      params: params,
      data: data,
    })
  },

  RemoveTrackers: function (params, data) {
    return request({
      url: setting.getFullUrl(TYPE, 'RemoveTrackers'),
      method: 'post',
      params: params,
      data: data,
    })
  },

  // 剪切设备到账号(转移归属关系 permission=99, 设备剩余有效期跟随设备)
  // 返回码: 0 成功 -2 账号无权限 -8 目标账号配额不足 -99 数据库错误
  CutTracker: function (params, data) {
    return request({
      url: setting.getFullUrl('TrackerBackend', 'CutTracker'),
      method: 'post',
      params: params,
      data: data,
    })
  },

  ChangeImei: function (params) {
    return request({
      url: setting.getFullUrl(TYPE, 'ChangeImei'),
      method: 'post',
      params: params,
    })
  },
  // 设备级：更新状态图标设置
  updateStatusIcons: function (data) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'UpdateStatusIcons'),
      method: 'post',
      data: data,
    })
  },

  // 设备级：更新地图图标设置
  updateMapIcons: function (data) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'UpdateMapIcons'),
      method: 'post',
      data: data,
    })
  },

  // 设备级：获取状态图标配置
  getStatusIcons: function (deviceId) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetStatusIcons'),
      headers: { 'X-Device-Id': deviceId },
      method: 'get',
    })
  },

  // 设备级：获取地图图标配置
  getMapIcon: function (deviceId) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetMapIcon'),
      headers: { 'X-Device-Id': deviceId },
      method: 'get',
    })
  },

  // 获取设备图标列表的列定义
  getDeviceIconColumns: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetDeviceIconColumns'),
      method: 'get',
    })
  },

  // 获取设备图标列表数据
  getDeviceIconList: function (params) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetDeviceIconList'),
      method: 'get',
      params: params,
    })
  },

  // 获取系统状态图标集列表
  getSystemStatusIconSets: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetSystemStatusIconSets'),
      method: 'get',
    })
  },

  // 获取系统地图图标集列表
  getSystemMapIconSets: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetSystemMapIconSets'),
      method: 'get',
    })
  },

  // 获取系统预设的自定义地图图标（3个默认图标）
  getSystemCustomMapIcons: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetSystemCustomMapIcons'),
      method: 'get',
    })
  },

  // 获取颜色选项列表
  getColorOptions: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetColorOptions'),
      method: 'get',
    })
  },

  // 获取状态类型列表
  getStatusTypes: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetStatusTypes'),
      method: 'get',
    })
  },

  // 聚合：获取“系统+自定义+已上传”的状态图标集合
  getStatusIconPalette: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetStatusIconPalette'),
      method: 'get',
    })
  },

  // 账号级：获取自定义状态图标集
  getCustomStatusIconSets: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetCustomStatusIconSets'),
      method: 'get',
    })
  },

  // 账号级：保存自定义状态图标集
  saveCustomStatusIconSets: function (data) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'SaveCustomStatusIconSets'),
      method: 'post',
      data: data,
    })
  },

  // 账号级：获取最近上传的状态图标
  getUploadedStatusIcons: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetUploadedStatusIcons'),
      method: 'get',
    })
  },

  // 账号级：保存最近上传的状态图标
  saveUploadedStatusIcons: function (data) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'SaveUploadedStatusIcons'),
      method: 'post',
      data: data,
    })
  },

  // 获取地图图标样式列表
  getMapIconStyles: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetMapIconStyles'),
      method: 'get',
    })
  },

  // 账号级：获取自定义地图图标分类
  getCustomMapCategories: function () {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'GetCustomMapCategories'),
      method: 'get',
    })
  },

  // 账号级：保存自定义地图图标分类
  saveCustomMapCategories: function (data) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'SaveCustomMapCategories'),
      method: 'post',
      data: data,
    })
  },

  // 删除自定义地图图标
  deleteCustomMapIcon: function (data) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'DeleteCustomMapIcon'),
      method: 'post',
      data: data,
    })
  },

  // 删除自定义地图图标分类
  deleteCustomMapCategory: function (data) {
    return request({
      url: setting.getFullUrl(DEVICE_ICON, 'DeleteCustomMapCategory'),
      method: 'post',
      data: data,
    })
  },
}

export default myfunction
